<!--
通用普通页面模板
-->
<style lang="less" scoped>
  @import "~@/public/less/index.less";
  .z-plugin-list{
    width: 100%; height: 100% !important; overflow: hidden;
    .head{
      .flexRow();
      .return{
        margin: 0 20px 20px 20px; font-size: 1.1em; font-weight: bold; cursor: pointer;
      }
    }
    .subHead{
      margin: 0 20px 20px 20px;
    }
  }
</style>
<template>
  <div class="zee zee-component z-plugin-list">
    <z-layout ref="zlayout"
              v-if="superApi"
              :superPage="superPage"
              :superApi="superApi"
              @reloadData="reloadData">
      <!-- 面包屑 -->
      <div slot="breadcrumb"></div>
      <!-- 头部 -->
      <template slot="head" v-if="superTitle || $slots.subHead">
        <div class="head" v-if="superTitle && returnUrl && returnUrl.url!=='/'">
          <div class="return" @click="$fan.page.open(returnUrl.url, returnUrl.query)">
            <a-icon type="left" /> {{superTitle || router.info.name}}
          </div>
        </div>
        <div class="subHead" v-if="$slots.subHead"><slot name="subHead"></slot></div>
      </template>
      <!-- 检索 -->
      <template slot="subHeadLeft" v-if="$slots.subHeadLeft">
        <slot name="subHeadLeft"></slot>
      </template>
      <!-- 按钮组 -->
      <template slot="subHeadRight" v-if="$slots.subHeadRight">
        <slot name="subHeadRight"></slot>
      </template>
      <!-- 子菜单 -->
      <template slot="menus" v-if="menus && !router.navInfo.hasTmp">
        <a-menu mode="inline"
                :style="{ height: '100%', borderRight: 0 }"
                :defaultOpenKeys="[`/${router.info.path[0]}/${router.info.path[1]}`]"
                :defaultSelectedKeys="[`${router.info.url}`]">
          <template v-for="(item, index) in menus">
            <a-sub-menu :key="index"
                        v-if="item.info.show &&
                              item.info.type==='nav' &&
                              item.info.level===(router.navInfo.level+1) &&
                              !item.info.hasTmp && item.info.hasChild">
              <span slot="title">
                <a-icon :type="item.info.icon" />
                <span>{{item.info.name}}</span>
              </span>
              <template v-for="(item2, index2) in menus">
                <a-menu-item :key="index2"
                             v-if="item2.info.type==='nav' &&
                                   item2.info.level===(router.navInfo.level+2)"
                             @click="$fan.page.open(index2)">
                    <span>
                      <a-icon :type="item2.info.icon" />
                      <span>{{item2.info.name}}</span>
                    </span>
                </a-menu-item>
              </template>
            </a-sub-menu>
            <a-menu-item :key="'menu-' + index"
                         v-else-if="item.info.show &&
                                    item.info.level===(router.navInfo.level+1) &&
                                    item.info.hasTmp"
                         @click="$fan.page.open(index)">
                  <span>
                    <a-icon :type="item.info.icon" />
                    <span>{{item.info.name}}</span>
                  </span>
            </a-menu-item>
          </template>
        </a-menu>
      </template>
      <!-- 主体内容 -->
      <template slot="body" v-if="$slots.body">
        <slot name="body"></slot>
      </template>
      <!-- 附属内容 -->
      <div slot="minor" v-if="$slots.minor">
        <slot name="minor"></slot>
      </div>
    </z-layout>
  </div>
</template>

<script>
  export default {
    name: 'ZPluginList',
    props: {
      superTitle: String,
      superPage: Object,
      superApi: String
    },
    computed: {
      routers() {
        return this.$store.state.routers || {}
      },
      router() {
        return this.routers[this.$route.path] || {}
      },
      query() {
        const query = this.$route.query
        if (this.$fan.utils.notEmpty(query)) {
          return query
        } else {
          return false
        }
      },
      menus() {
        let menus = {}
        if (this.router && this.router.navInfo && this.router.navInfo.hasChild) {
          for (let k in this.routers) {
            const router = this.routers[k]
            let routerNavUrl = ""
            for (let i =0; i < this.router.navInfo.level; i++) {
              routerNavUrl = routerNavUrl+"/"+router.info.path[i]
            }
            if (router.info.type!=='nav' && routerNavUrl===this.router.navInfo.url) {
              menus[router.info.url] = router
            }
          }
        }
        return Object.keys(menus).length>0 ? menus : false
      },
      returnUrl() {
        const breadcrumb = this.router.info.breadcrumb
        if (breadcrumb.length > 2) {
          let returnUrl = {name: "首页", icon: "home", url: "/", query: {}}
          if (breadcrumb[breadcrumb.length-2] && this.routers[breadcrumb[breadcrumb.length-2].url].info.hasTmp) {
            returnUrl = breadcrumb[breadcrumb.length-2]
          } else if (breadcrumb[breadcrumb.length-3] && this.routers[breadcrumb[breadcrumb.length-3].url].info.hasTmp) {
            returnUrl = breadcrumb[breadcrumb.length-3]
          } else if (breadcrumb[breadcrumb.length-4] && this.routers[breadcrumb[breadcrumb.length-4].url].info.hasTmp) {
            returnUrl = breadcrumb[breadcrumb.length-4]
          }
          const query =  this.$fan.storage.getStorage('fan-page_query', this.router.topInfo.url)
          returnUrl.query = query
          return returnUrl
        } else {
          return {name: "首页", icon: "home", url: "/", query: {}}
        }
      },
    },
    methods: {
      reloadData() {
        this.$emit('reloadData')
      },
      bindOpenCurd(title, record) {
        this.$refs.zlayout.bindOpenCurd(title, record)
      }
    }
  }
</script>
